import {
    measurement,
} from '@gov.wa.lni/application.janitorial-workload-calculator/source/logic/helpers';

import Types from '@gov.wa.lni/application.janitorial-workload-calculator/source/logic/enums/types';

export default {
    namespaced: 'true',
    state: {
        content: {},
        contentGenericIds: {
            disclaimer: '49ff08bc5d19327558c0d499b35dd013',
            ergonomicEvaluationIntro: '569bf3e40507d6eade6fc9119b022cd3',
            intro: '804c2cf316f7474f39e1a188ee559364',
            jobReportIntro: '4b7f1383c3db47929c217022486425ef',
            managementReportIntro: '42276ba89df10e6e4bd85022091c867a',
            usage: 'fd9d4c259edbaf3f5df96c3c007aaa43',
        },
        contentId: '37144ac7cb76d5137292b76aaaef343c',
        data: null,
        editIndex: null,
        isInitialized: false,
        isLoading: true,
        jobPlan: [],
        name: '',
        selectedJob: null,
        type: '',
    },
    getters: {
        content: state => state.content,
        contentGenericIds: state => state.contentGenericIds,
        contentId: state => state.contentId,
        editIndex: state => state.editIndex,
        isErgonomicEvaluation: state => state.type === Types.Ergonomic,
        isJobPlanReport: state => state.type === Types.Job,
        isLoading: state => state?.isLoading,
        isManagementReport: state => state.type === Types.Management,
        jobPlan: state => state.jobPlan,
        measurementText(state) {
            return state.selectedJob ? measurement(state.data.measurementTypes, state.selectedJob.measurement).text : '---';
        },
        name: state => state.name,
        tableColumns: state => columns => {
            const result = [
                {
                    source: 'index',
                    displayText: state.content.tableIdColumn,
                    sortable: true,
                    headerClasses: 'lni-u-text--center',
                },
                {
                    source: 'assignment',
                    displayText: state.content.activityHeading,
                    sortable: true,
                    headerClasses: 'lni-u-text--left',
                },
            ];
            for (const col of columns) {
                const c = {
                    source: col.source,
                    displayText: col.displayText,
                    sortable: col.sortable === undefined ? true : col.sortable,
                    headerClasses: col.headerClasses === undefined ? 'lni-u-text--center' : col.headerClasses,
                };
                result.push(c);
            }

            return result;
        },
        type: state => state.type,
    },
    mutations: {
        REMOVE_FROM_JOB_PLAN(state, payload) {
            state.jobPlan.splice(payload, 1);
        },
        SET_CONTENT(state, payload) {
            state.content[payload.key] = payload.value;
        },
        SET_EDIT_INDEX(state, payload) {
            state.editIndex = payload;
            if (state.editIndex === null) {
                state.selectedJob = null;
            } else {
                state.selectedJob = state.jobPlan[state.editIndex];
            }
        },
        SET_VALUE(state, payload) {
            state[payload.key] = payload.value;
        },
        UPDATE_JOB_PLAN(state, payload) {
            if (payload.index || Number(payload.index) === 0) {
                state.jobPlan[payload.index] = payload.value;
            } else {
                state.jobPlan.push(payload.value);
            }
        },
    },
};